export default class LundiBixi{
	constructor(){
		let language = document.documentElement.getAttribute('lang').substring(0, 2);
		let subCodeForm = document.querySelector('#subBixiCode');
        let subCodeFormEmail = subCodeForm.ci_email;
        
        subCodeForm.addEventListener('submit', onSubmitForm);

		function onSubmitForm(e){
        	e.preventDefault();
            let dataForm = new FormData();
            dataForm.append('ci_email', subCodeFormEmail.value);
            dataForm.append('lang', language);

			axios.post('/wp-admin/admin-ajax.php?action=send_bixi_code', dataForm).then( response => {
			    //Emit response to parent
			    if(response.data.success){
		    		console.log(response.data);
		    		subCodeForm.submit();
		    		// subCodeForm.querySelector('.form-container').style.display = "none";
		    		// subCodeForm.querySelector('.success').style.display = "block";
		    	}
			    else{
			    	if(response.data.message){
			    		console.log(response.data.message);
		    			subCodeForm.querySelector('.error').innerHTML = response.data.message;
			    	}
		    		subCodeForm.querySelector('.form-container').style.display = "none";
		    		subCodeForm.querySelector('.error').style.display = "block";
		    	}
			}).catch((err) => console.error(err));
		}
	}
}